import { Component, OnInit, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ApiService } from "src/app/api.service";
import { TokenizedConfigTemplate, UserInputSection, AssetConfigIdentifiers } from "src/app/config-template";
import { DvsUtilities } from "src/app/dvs-utilities";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-templated-config",
	templateUrl: "./templated-config.component.html",
	styleUrls: ["./templated-config.component.scss"],
	imports: [FormsModule, ActionButtonComponent]
})
export class TemplatedConfigComponent implements OnInit {
	api = inject(ApiService);

	public templates: APIResults.ConfigTemplate[];
	public organizations: APIResults.Organization[];
	public selectedTemplate: APIResults.ConfigTemplate;
	public rawTemplate: string;
	public template: TokenizedConfigTemplate;
	public userinputgroups: UserInputSection[];
	public assetconfig: string;
	public selectedOrganization: APIResults.Organization;
	public ident: AssetConfigIdentifiers;

	public loaderrormessage = "";

	ngOnInit() {
		this.UpdateTemplates();
		this.UpdateOrganizations();
	}

	async UpdateTemplates() {
		const templates = await this.api.GetAllTemplates();
		this.templates = templates;
	}
	async UpdateOrganizations() {
		const organizations = await this.api.GetOrganizations();
		this.organizations = organizations;
	}

	async templateChange(template: APIResults.ConfigTemplate) {
		this.rawTemplate = undefined;
		this.template = undefined;
		this.userinputgroups = undefined;
		this.assetconfig = undefined;
		this.selectedOrganization = undefined;
		this.ident = undefined;

		this.loaderrormessage = "";
		try {
			try {
				this.rawTemplate = await this.api.GetTemplateContent(template.template_id);
			} catch (apierr) {
				try {
					// Since result is text, error doesn't get parsed
					const parsed = JSON.parse(apierr.error);
					apierr.error = parsed;
					throw apierr;
				} catch {
					throw apierr;
				}
			}
			this.template = new TokenizedConfigTemplate(this.rawTemplate);
			this.userinputgroups = this.template.GetGroupedUserInputs();
		} catch (err) {
			this.loaderrormessage = DvsUtilities.GetRemoteErrorMessage(err, "Couldn't load template");
		}
	}

	public GenerateConfig() {
		try {
			this.assetconfig = this.template.Populate();
			this.ident = this.template.GetIdentifiers();
		} catch (err) {
			// let message = err.error ? err.error.message : err.message;
			if (err.token) {
				err.message += " for field: " + err.token.description;
			}
			throw err;
		}
	}

	public GoBack() {
		this.assetconfig = undefined;
		this.ident = undefined;
	}

	public async SaveConfig() {
		try {
			await this.api.AddConfig(this.selectedOrganization.organization_id, this.assetconfig);
		} catch (err) {
			// let message = err.error ? err.error.message : err.message;
			if (err.message.startsWith("ER_DUP_ENTRY")) {
				err.message = "A configuration with the name " + this.ident.type + " already exists";
			}
			throw err;
		}
	}

}
